export default __webpack_public_path__ + "static/media/tick.b841a99a.svg";